export const paths = {
	root: '/ibAdmin',
    notifications: '/ibAdmin/notifications',
    actions: {
        createIB: '/ibAdmin/createIB',
        edit: '/ibAdmin/:safetyId/edit',
        disable: '/ibAdmin/:safetyId/disableSafetyLetterPopup',
        setup: '/ibAdmin/setupIBDistribution/:safetyId/:safetyCountryId',
        view: '/ibAdmin/:safetyId/view',
        viewIBStudyDoc: '/ibAdmin/setupIBDistribution/:safetyId/:safetyCountryId/viewStudyDoc/:safetyCountryStudyId'      
    },
    details: {
        root: '/ibAdmin/:safetyId',
        ibReport: '/ibAdmin/reports',
    }
};
export const navigation = {
    actions: {
        editIB: safetyId => `/ibAdmin/${safetyId}/edit`,
        viewIB: (safetyId, countryId = null) =>
            countryId
                ? `/ibAdmin/${safetyId}/view?${countryId}`
                : `/ibAdmin/${safetyId}/view`,
        disable: safetyId => `/ibAdmin/${safetyId}/disableSafetyLetterPopup`,
        setup: (safetyId, countryId) => `/ibAdmin/setupIBDistribution/${safetyId}/${countryId}`,
        viewIBStudyDoc: (safetyId, safetyCountryId, safetyCountryStudyId) =>`/ibAdmin/setupIBDistribution/${safetyId}/${safetyCountryId}/viewStudyDoc/${safetyCountryStudyId}`
    },
    details: {
        root: safetyId => `/ibAdmin/${safetyId}`,
        individualRecipients: (safetyId, organizationId) =>
            `/ibAdmin/${safetyId}/recipients/${organizationId}`,
        report: reportTypeSelected => `/ibAdmin/reports/${reportTypeSelected}`
    }
};